import { DateTime } from 'luxon';
import { FlexCalSummary } from '../types';

export function getFlexStartAndEndDate(flexCal: FlexCalSummary) {
  const start = flexCal.evergreen
    ? DateTime.now().startOf('day')
    : DateTime.fromISO(flexCal.startDate);

  const scheduleInAdvanceWeek = DateTime.fromISO(flexCal.endDate).diff(
    DateTime.fromISO(flexCal.startDate),
    'weeks'
  ).weeks;

  const end = flexCal.evergreen
    ? start
        .plus({
          weeks: scheduleInAdvanceWeek,
          day: -1,
        })
        .endOf('day')
    : DateTime.fromISO(flexCal.endDate);
  return { start, end };
}
